/**
 * Deletes a file from a specific container in Azure Blob Storage.
 * @param containerName - Name of the blob container
 * @param fileName - Name of the file (blob) to delete
 */
export async function deleteFile(containerName: string, fileName: string): Promise<void> {
  const response = await fetch(
    `/api/deleteFile?container=${encodeURIComponent(containerName)}&file=${encodeURIComponent(fileName)}`,
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    },
  );

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error deleting file: ${errorText || response.statusText}`);
  }
}
